<template>
  <transition name="slide-fade">
    <div v-if="visible" class="notification-card">
      <div class="header">
        <span class="title">New Patient Registered</span>
        <button class="close" @click="close">×</button>
      </div>
      <div class="content">
        <div class="row"><span class="label">Name</span><span class="value">{{ data.name }}</span></div>
        <div class="row"><span class="label">Patient ID</span><span class="value badge">{{ data.patient_id }}</span></div>
        <div class="row"><span class="label">Gender</span><span class="value">{{ data.gender }}</span></div>
        <div class="row"><span class="label">Telephone</span><span class="value">{{ data.telephone }}</span></div>
        <div class="row"><span class="label">Address</span><span class="value">{{ data.address }}</span></div>
        <div class="timestamp">{{ formattedDate }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "PatientNotification",
  props: {
    data: { type: Object, required: true }
  },
  data() {
    return {
      visible: false,
      audio: null,
    }
  },
  computed: {
    formattedDate() {
      return new Date(this.data.created_at).toLocaleString()
    },
  },
  mounted() {
    this.audio = new Audio("/sounds/notification.mp3")
    this.show()
  },
  methods: {
    show() {
      this.visible = true
      this.audio.play().catch(() => {})
      setTimeout(this.close, 10000)
    },
    close() {
      this.visible = false
      this.$emit("close")
    },
  },
}
</script>

<style scoped>
.notification-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  font-family: Inter, system-ui, sans-serif;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #216035, #145a35);
  color: white;
  padding: 14px 16px;
}

.title { font-weight: 600; font-size: 14px; }

.close { background: none; border: none; color: white; font-size: 18px; cursor: pointer; }

.content { padding: 16px; }

.row { display: flex; justify-content: space-between; margin-bottom: 8px; }
.label { color: #6b7280; font-size: 13px; }
.value { font-weight: 500; font-size: 13px; color: #111827; }
.badge { background: #e0e7ff; color: #276d38; padding: 2px 8px; border-radius: 6px; font-size: 12px; }
.timestamp { margin-top: 12px; font-size: 11px; color: #9ca3af; text-align: right; }

.slide-fade-enter-active, .slide-fade-leave-active { transition: all 0.3s ease; }
.slide-fade-enter, .slide-fade-leave-to { transform: translateX(100%); opacity: 0; }
</style>
